/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetEarningTransactionsParams,
  GetEarningsParams,
  GetEngagementCount200,
  GetEngagementCountParams,
  GetEngagementsParams,
  GetTopContentParams,
  PageResponseEarningTransactionResponseDTO,
  PageResponsePostResponseDTO,
  TimeSlicedStatisticsDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Get top performing content
 */
export const getTopContent = (
  userId: number,
  params: GetTopContentParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageResponsePostResponseDTO>({
    url: `/api/v3/${userId}/statistics/top-content`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetTopContentQueryKey = (userId?: number, params?: GetTopContentParams) => {
  return [`/api/v3/${userId}/statistics/top-content`, ...(params ? [params] : [])] as const;
};

export const getGetTopContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopContent>>,
  TError = unknown,
>(
  userId: number,
  params: GetTopContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopContent>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopContentQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopContent>>> = ({ signal }) =>
    getTopContent(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopContentQueryResult = NonNullable<Awaited<ReturnType<typeof getTopContent>>>;
export type GetTopContentQueryError = unknown;

export function useGetTopContent<
  TData = Awaited<ReturnType<typeof getTopContent>>,
  TError = unknown,
>(
  userId: number,
  params: GetTopContentParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopContent>>,
          TError,
          Awaited<ReturnType<typeof getTopContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopContent<
  TData = Awaited<ReturnType<typeof getTopContent>>,
  TError = unknown,
>(
  userId: number,
  params: GetTopContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopContent>>,
          TError,
          Awaited<ReturnType<typeof getTopContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopContent<
  TData = Awaited<ReturnType<typeof getTopContent>>,
  TError = unknown,
>(
  userId: number,
  params: GetTopContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopContent>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get top performing content
 */

export function useGetTopContent<
  TData = Awaited<ReturnType<typeof getTopContent>>,
  TError = unknown,
>(
  userId: number,
  params: GetTopContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopContent>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopContentQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get engagements over time
 */
export const getEngagements = (
  userId: string,
  params: GetEngagementsParams,
  signal?: AbortSignal,
) => {
  return customInstance<TimeSlicedStatisticsDTO>({
    url: `/api/v3/${userId}/statistics/engagements`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetEngagementsQueryKey = (userId?: string, params?: GetEngagementsParams) => {
  return [`/api/v3/${userId}/statistics/engagements`, ...(params ? [params] : [])] as const;
};

export const getGetEngagementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEngagements>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagements>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEngagementsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngagements>>> = ({ signal }) =>
    getEngagements(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEngagements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEngagementsQueryResult = NonNullable<Awaited<ReturnType<typeof getEngagements>>>;
export type GetEngagementsQueryError = unknown;

export function useGetEngagements<
  TData = Awaited<ReturnType<typeof getEngagements>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagements>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagements>>,
          TError,
          Awaited<ReturnType<typeof getEngagements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagements<
  TData = Awaited<ReturnType<typeof getEngagements>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagements>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagements>>,
          TError,
          Awaited<ReturnType<typeof getEngagements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagements<
  TData = Awaited<ReturnType<typeof getEngagements>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagements>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get engagements over time
 */

export function useGetEngagements<
  TData = Awaited<ReturnType<typeof getEngagements>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagements>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEngagementsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get engagement counts
 */
export const getEngagementCount = (
  userId: string,
  params: GetEngagementCountParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetEngagementCount200>({
    url: `/api/v3/${userId}/statistics/engagement-count`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetEngagementCountQueryKey = (
  userId?: string,
  params?: GetEngagementCountParams,
) => {
  return [`/api/v3/${userId}/statistics/engagement-count`, ...(params ? [params] : [])] as const;
};

export const getGetEngagementCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getEngagementCount>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagementCount>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEngagementCountQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngagementCount>>> = ({ signal }) =>
    getEngagementCount(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEngagementCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEngagementCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEngagementCount>>
>;
export type GetEngagementCountQueryError = unknown;

export function useGetEngagementCount<
  TData = Awaited<ReturnType<typeof getEngagementCount>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementCountParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagementCount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementCount>>,
          TError,
          Awaited<ReturnType<typeof getEngagementCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagementCount<
  TData = Awaited<ReturnType<typeof getEngagementCount>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementCount>>,
          TError,
          Awaited<ReturnType<typeof getEngagementCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagementCount<
  TData = Awaited<ReturnType<typeof getEngagementCount>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagementCount>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get engagement counts
 */

export function useGetEngagementCount<
  TData = Awaited<ReturnType<typeof getEngagementCount>>,
  TError = unknown,
>(
  userId: string,
  params: GetEngagementCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngagementCount>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEngagementCountQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get categorised earnings over time
 */
export const getEarnings = (userId: string, params: GetEarningsParams, signal?: AbortSignal) => {
  return customInstance<TimeSlicedStatisticsDTO>({
    url: `/api/v3/${userId}/statistics/earnings`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetEarningsQueryKey = (userId?: string, params?: GetEarningsParams) => {
  return [`/api/v3/${userId}/statistics/earnings`, ...(params ? [params] : [])] as const;
};

export const getGetEarningsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEarnings>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEarnings>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEarningsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEarnings>>> = ({ signal }) =>
    getEarnings(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEarnings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getEarnings>>>;
export type GetEarningsQueryError = unknown;

export function useGetEarnings<TData = Awaited<ReturnType<typeof getEarnings>>, TError = unknown>(
  userId: string,
  params: GetEarningsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEarnings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEarnings>>,
          TError,
          Awaited<ReturnType<typeof getEarnings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEarnings<TData = Awaited<ReturnType<typeof getEarnings>>, TError = unknown>(
  userId: string,
  params: GetEarningsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEarnings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEarnings>>,
          TError,
          Awaited<ReturnType<typeof getEarnings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEarnings<TData = Awaited<ReturnType<typeof getEarnings>>, TError = unknown>(
  userId: string,
  params: GetEarningsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEarnings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get categorised earnings over time
 */

export function useGetEarnings<TData = Awaited<ReturnType<typeof getEarnings>>, TError = unknown>(
  userId: string,
  params: GetEarningsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEarnings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEarningsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get earning transaction history
 */
export const getEarningTransactions = (
  userId: string,
  params: GetEarningTransactionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageResponseEarningTransactionResponseDTO>({
    url: `/api/v3/${userId}/statistics/earnings/transactions`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetEarningTransactionsQueryKey = (
  userId?: string,
  params?: GetEarningTransactionsParams,
) => {
  return [
    `/api/v3/${userId}/statistics/earnings/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEarningTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEarningTransactions>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEarningTransactions>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEarningTransactionsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEarningTransactions>>> = ({ signal }) =>
    getEarningTransactions(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEarningTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEarningTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEarningTransactions>>
>;
export type GetEarningTransactionsQueryError = unknown;

export function useGetEarningTransactions<
  TData = Awaited<ReturnType<typeof getEarningTransactions>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEarningTransactions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEarningTransactions>>,
          TError,
          Awaited<ReturnType<typeof getEarningTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEarningTransactions<
  TData = Awaited<ReturnType<typeof getEarningTransactions>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEarningTransactions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEarningTransactions>>,
          TError,
          Awaited<ReturnType<typeof getEarningTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEarningTransactions<
  TData = Awaited<ReturnType<typeof getEarningTransactions>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEarningTransactions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get earning transaction history
 */

export function useGetEarningTransactions<
  TData = Awaited<ReturnType<typeof getEarningTransactions>>,
  TError = unknown,
>(
  userId: string,
  params: GetEarningTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEarningTransactions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEarningTransactionsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
